<mat-card-content>
  <input type="file"
    [disabled]="loading$ | async"
    [style.display]="'none'"
    #fileInput
    accept=".csv,.xls,.xlsx"
    (change)="changed()">
  <button mat-flat-button
    [disabled]="loading$ | async"
    (click)="fileInput.click()">Select File</button>
</mat-card-content>

<mat-card-content *ngIf="file">
  <mat-card-subtitle>Data Preview</mat-card-subtitle>
  <mat-card-actions align="end">
    <a (click)="submit()"
      *ngIf="!(results$ | async)"
      [disabled]="loading$ | async"
      mat-flat-button>Import</a>
  </mat-card-actions>
  <mat-progress-bar mode="indeterminate"
    *ngIf="loading$ | async"></mat-progress-bar>
  <ca-csv-preview [config]="config"
    [loading]="loading$ | async"
    [error]="error$ | async"
    [results]="results$ | async"
    [form]="form"
    [file]="file"></ca-csv-preview>
</mat-card-content>